/** School fee mobile-money (OneKhusa) — enabled for bursar/student fee collection. */
export const ENABLE_FEE_ONLINE_PAYMENT = true;

/** Subscription mobile-money via OneKhusa (registration + renewal). */
export const ENABLE_SUBSCRIPTION_ONLINE_PAYMENT = true;
